export default __webpack_public_path__ + "static/media/gileadLogo.9811bfe0.png";